/**
 * FE-3: "StatusBadge maps every payment, key, endpoint and event status to a
 * colour, in one place. Status colour is never chosen at the call site."
 *
 * FE-14: colour is never the only carrier of meaning — every badge pairs its
 * tone with a written label.
 */
const TONES = {
  success: 'chip-success',
  warning: 'chip-warning',
  danger: 'chip-danger',
  info: 'chip-info',
  neutral: 'chip-neutral',
  accent: 'chip',
};

const STATUS_MAP = {
  /* Payments (PL-1) */
  pending: { tone: 'neutral', label: 'Pending' },
  processing: { tone: 'info', label: 'Processing' },
  succeeded: { tone: 'success', label: 'Succeeded' },
  failed: { tone: 'danger', label: 'Failed' },
  cancelled: { tone: 'neutral', label: 'Cancelled' },
  refunded: { tone: 'warning', label: 'Refunded' },
  partially_refunded: { tone: 'warning', label: 'Partly refunded' },

  /* API keys (AK-5) */
  active: { tone: 'success', label: 'Active' },
  revoked: { tone: 'danger', label: 'Revoked' },

  /* Webhook endpoints (WH-9) */
  disabled: { tone: 'danger', label: 'Disabled' },

  /* Webhook events (WH-8) */
  delivering: { tone: 'info', label: 'Delivering' },
  delivered: { tone: 'success', label: 'Delivered' },
  exhausted: { tone: 'danger', label: 'Gave up' },

  /* Merchants (MA-8, AD-3) */
  onboarding: { tone: 'warning', label: 'Onboarding' },
  suspended: { tone: 'danger', label: 'Suspended' },

  /* Provider connections (PP-7) */
  connected: { tone: 'success', label: 'Connected' },
  error: { tone: 'danger', label: 'Needs attention' },

  /* Refunds (RF-5) */
  needs_reconciliation: { tone: 'warning', label: 'Needs reconciliation' },

  /* Checkout sessions (HC-10) */
  open: { tone: 'info', label: 'Open' },
  completed: { tone: 'success', label: 'Completed' },
  expired: { tone: 'neutral', label: 'Expired' },

  /* Environments (PP-6) — a live charge must look different from a test one */
  sandbox: { tone: 'neutral', label: 'Test' },
  production: { tone: 'accent', label: 'Live' },
};

export const statusTone = (status) => STATUS_MAP[status]?.tone ?? 'neutral';

export function StatusBadge({ status, label, dot = true, className = '' }) {
  const entry = STATUS_MAP[status];
  const text = label ?? entry?.label ?? String(status ?? 'Unknown').replace(/_/g, ' ');

  return (
    <span className={`${TONES[entry?.tone ?? 'neutral']} ${className}`}>
      {dot && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" />}
      {text}
    </span>
  );
}

export default StatusBadge;
